// extracted by mini-css-extract-plugin
export var quillEditor = "_pq-1";
export var variable = "_pq-0";